export const LogoMark = ({ className = "w-9 h-9" }) => (
  <img src="/logo-icon.png" alt="Deal 2 Wheel" className={`${className} object-contain`} data-testid="logo-mark" />
);

export const Logo = () => (
  <img src="/logo-full.png" alt="Deal 2 Wheel — We Buy & Sell Used Two Wheelers" className="h-11 md:h-14 w-auto object-contain" data-testid="site-logo" />
);

export default Logo;
